export default __webpack_public_path__ + "static/media/temp-gray.73b48604.svg";